module.exports = __webpack_public_path__ + "static/media/bh.58c03b67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/bh.svg
// module id = 1433
// module chunks = 0